'use client'

import { useState, useEffect } from 'react'
import { X, Heart } from 'lucide-react'

const STORAGE_KEY = 'cake-shop-follow-dismissed'

export default function FollowPopup() {
  const [show, setShow] = useState(false)
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const dismissed = localStorage.getItem(STORAGE_KEY)
    if (!dismissed) {
      // 延迟 1.5 秒弹出，避免阻塞首屏
      const timer = setTimeout(() => {
        setShow(true)
        requestAnimationFrame(() => setVisible(true))
      }, 1500)
      return () => clearTimeout(timer)
    }
  }, [])

  const handleClose = () => {
    setVisible(false)
    setTimeout(() => setShow(false), 300)
    localStorage.setItem(STORAGE_KEY, 'true')
  }

  if (!show) return null

  return (
    <div className={`fixed inset-0 z-[100] flex items-center justify-center transition-all duration-300 ${visible ? 'bg-black/40' : 'bg-transparent'}`}>
      <div
        className={`bg-white rounded-2xl mx-6 w-full max-w-sm overflow-hidden transition-all duration-300 ${visible ? 'opacity-100 scale-100' : 'opacity-0 scale-90'}`}
        onClick={(e) => e.stopPropagation()}
      >
        {/* 顶部装饰 */}
        <div className="relative h-32 bg-gradient-to-br from-pink-400 via-rose-400 to-orange-300 flex items-center justify-center">
          <button onClick={handleClose} className="absolute top-3 right-3 p-1 rounded-full bg-white/20 hover:bg-white/30 transition-colors">
            <X className="w-4 h-4 text-white" />
          </button>
          <div className="text-center text-white">
            <Heart className="w-10 h-10 mx-auto mb-1 fill-white" />
            <p className="text-lg font-bold">甜蜜时光</p>
            <p className="text-[11px] opacity-80">关注公众号 · 享专属福利</p>
          </div>
        </div>

        {/* 内容 */}
        <div className="p-5">
          <div className="flex items-center justify-center gap-4 mb-4">
            <div className="w-24 h-24 bg-gray-100 rounded-xl flex flex-col items-center justify-center">
              <div className="w-20 h-20 bg-white rounded-lg border border-gray-200 flex items-center justify-center">
                <div className="text-center">
                  <div className="w-14 h-14 bg-gray-50 rounded flex items-center justify-center">
                    <span className="text-[10px] text-gray-400">公众号二维码</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="space-y-2">
              <div className="flex items-center gap-1.5">
                <div className="w-1.5 h-1.5 rounded-full bg-green-400" />
                <span className="text-xs text-gray-600">新品抢先尝</span>
              </div>
              <div className="flex items-center gap-1.5">
                <div className="w-1.5 h-1.5 rounded-full bg-pink-400" />
                <span className="text-xs text-gray-600">专属优惠券</span>
              </div>
              <div className="flex items-center gap-1.5">
                <div className="w-1.5 h-1.5 rounded-full bg-amber-400" />
                <span className="text-xs text-gray-600">生日月惊喜</span>
              </div>
              <div className="flex items-center gap-1.5">
                <div className="w-1.5 h-1.5 rounded-full bg-violet-400" />
                <span className="text-xs text-gray-600">会员积分翻倍</span>
              </div>
            </div>
          </div>
          <p className="text-[10px] text-gray-400 text-center mb-3">长按识别二维码关注「甜蜜时光」公众号</p>
          <button onClick={handleClose} className="w-full py-2.5 bg-gradient-to-r from-pink-500 to-rose-400 text-white text-sm font-bold rounded-xl active:scale-[0.98] transition-transform">
            我知道了
          </button>
        </div>
      </div>
    </div>
  )
}
